export default __webpack_public_path__ + "images/20a38b7f9ebe77646724193cb8172d63-man photo.jpeg";